<template>
    <div>
        <div class="row h1 page-header">
            Order Checkout
            <button @click="makeOrder()" :disabled="orderInProgress" class="btn btn-success pull-right">Place Order</button>
        </div>

        <div class="row">
            <div class="panel panel-primary">
                <div class="panel-heading">
                    <h3 class="panel-title">Your Products</h3>
                </div>
                <p v-if="!products.length" class="text-center">
                    <i>Your cart is empty!</i>
                    <a href="/shop">Go shopping</a>
                </p>

                <div v-if="products.length">
                    <table class="table is-striped">
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>Item</th>
                                <th class="text-center">Quantity</th>
                                <th class="text-right">Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(product, index) in products">
                            <td>
                                <img :src="product.imageTinyThumbUrl">
                            </td>
                            <td>
                                {{ product.name }}
                                <template v-for="variant in product.selectedVariants">
                                    <br> <strong>{{ variant.label }}:</strong> {{ variant.value }}
                                </template>
                                <template v-if="product.personalisation">
                                    <br /><strong>Personalisation:</strong> {{ product.personalisation }}
                                </template>
                            </td>
                            <td class="text-center">{{ product.quantity }}</td>
                            <td class="text-right">{{ product.price | currency }}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="3" class="text-right"><h4>Total:</h4></td>
                                <td class="text-right"><h4>{{ total | currency }}</h4></td>
                            </tr>
                        </tfoot>
                    </table>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Form from '../../utils/Form';
    import { mapGetters, mapActions } from 'vuex';
    import { Alert, Message, Loading } from 'element-ui';
    import lang from 'element-ui/lib/locale/lang/en';
    import locale from 'element-ui/lib/locale';
    locale.use(lang);


    export default {
        components: { Alert, Message, Loading },
        data: function () {
            return {
                form: null,
				orderInProgress: false
            };
        },

        computed: {
            ...mapGetters({
                products: 'cart/all'
            }),

            total() {
                return this.products.reduce((total, p) => {
                    return total + p.price * p.quantity;
                }, 0);
            }
        },

        methods: {
            prepareForm() {
                let orderData = [];

                for (let product of this.products) {
                    orderData.push({
                        product_id: product.id,
                        price: product.price,
                        personalisation: product.personalisation,
                        quantity: product.quantity,
                        selectedVariants: product.selectedVariants
                    });
                }

                this.form = new Form({
                    products: orderData
                });
            },

            makeOrder() {
				this.orderInProgress = true;
                this.form.post(`/api/v1/orders`)
                    .then(response => {
                        this.resetCart();


                        this.$alert('Your order has been placed', 'Thank You', {
                                  confirmButtonText: 'OK',
                              });

                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem saving the order.', type: 'error'});
                    })
					.finally(() => {
						this.orderInProgress = false;
					})
				;
            },

            ...mapActions({
                getCart: 'cart/all',
                resetCart: 'cart/reset'
            })
        },

        mounted () {
            this.getCart();
            this.prepareForm();
        }
    }
</script>
